var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"flat":"","rounded":"lg"}},[_c('v-card-title',{staticClass:"primary--text"},[_vm._v("Minhas Áreas de interesse")]),_c('v-card-text',[(_vm.loading)?_c('v-progress-linear',{attrs:{"indeterminate":""}}):[_c('areas-interesse')]],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }